import { create } from "zustand";
import md5 from "blueimp-md5";
import { useNotificationState } from "../../../common/notifications/NotificationState";
import { appI18n } from "../../i18n/i18n";

export interface AppUpdateCheckerState {
    indexPageHash: string | null;
    refreshCurrentHash: () => Promise<void>;
    reloadIfHashUpdated: (warnFirst?: boolean) => Promise<void>;
}

export type AppUpdateCheckerService = AppUpdateCheckerState;

const fetchHash = async () => {
    return await fetch("/");
};

export const useAppUpdateCheckerState = create<AppUpdateCheckerState>((set, get) => ({
    indexPageHash: null,
    refreshCurrentHash: async () => {
        try {
            const result = await fetchHash();
            const data = await result.text();
            if (data) {
                set({ indexPageHash: md5(data) });
                console.debug(`Current Hash: ${md5(data)}`);
            }
        } catch (e) {
            console.debug(`Failed to update hash ${e}`);
            set({ indexPageHash: null });
        }
    },
    reloadIfHashUpdated: async (warnFirst = true) => {
        const currentHash = get().indexPageHash;
        await get().refreshCurrentHash();

        const refresh = () => window.location.reload();

        const newHash = get().indexPageHash;
        if (currentHash && newHash && currentHash !== newHash) {
            console.debug(`Page reload needed. Hash updated from ${currentHash} to ${newHash}`);
            if (warnFirst) {
                await useNotificationState
                    .getState()
                    .addNotification(appI18n.t("common:appUpdate.outdated"), "info", refresh, appI18n.t("common:actions.refresh"));
            } else {
                refresh();
            }
        } else {
            console.debug("checking for system updates");
        }
    },
}));
